// Hook: PUT /company/departments/{id}

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IRequest {
  location_id?: number;
  name?: string;
  short_name?: string | null;
  manager_user_id?: number | null;
  deputy_manager_user_id?: number | null;
  limit_enabled?: boolean;
  limit_period?: 'm' | 'q' | 'y' | null;
  limit_amount?: string | null;
  limit_visible_to_user?: boolean;
}

export interface IVariables {
  id: number;
  data: IRequest;
}

type IResponse = ICommandResponseSuccess;

const putCompanyDepartment = (id: number, data: IRequest): Promise<IResponse> =>
  axios.put(`/company/departments/${id}`, data);

export const usePutCompanyDepartment = (
  options?: UseMutationOptions<IResponse, IError, IVariables>
) =>
  useMutation(({ id, data }: IVariables) => putCompanyDepartment(id, data), options);
